import queryString from 'query-string';

import { ENV } from '@shared/config';
import { decodeHtmlEntities } from '@shared/utils';

// eslint-disable-next-line import/no-internal-modules
import { getClientNoCache } from '../server-utils';

export interface CommonReview {
  name: string;
  text: string;
  date: string;
  rating?: number;
}

export interface CommonReviewsPaginatedResponse {
  result_code: number;
  data: CommonReview[];
  lang: string;
  userID: string | null;
  pager: {
    page_current: number;
    pages_all: number;
    records_all: number;
    records_per_page: number;
  };
}

export async function getCommonReviewsPaginated({
  page = 1,
  pagelen = 20,
}: {
  page?: number;
  pagelen?: number;
} = {}): Promise<CommonReviewsPaginatedResponse> {
  const requestLink = `${ENV.API}/common_review_list/?${queryString.stringify({
    lang: ENV.LANG,
    page,
    pagelen,
  })}`;

  try {
    const noChach = await getClientNoCache();
    const res = await fetch(requestLink, {
      cache: noChach ? 'no-store' : undefined,
      next: noChach
        ? undefined
        : {
          revalidate: 1800, // Обновляем раз в 30 минут для пагинированных отзывов
          tags: ['common-reviews-paginated', `common-reviews-page-${page}`],
        },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}, statusText: ${res.statusText}`);
    }

    const response = await res.json() as CommonReviewsPaginatedResponse;

    return {
      ...response,
      data: decodeHtmlEntities(response.data),
      pager: response.pager || {
        page_current: page,
        pages_all: 0,
        records_all: 0,
        records_per_page: pagelen,
      },
    };
  } catch (error) {
    console.error('Error fetching paginated common reviews:', error);
    
    // Возвращаем пустой ответ с базовой пагинацией при ошибке
    return {
      result_code: 500,
      data: [],
      lang: ENV.LANG,
      userID: null,
      pager: {
        page_current: page,
        pages_all: 0,
        records_all: 0,
        records_per_page: pagelen,
      },
    };
  }
}
